import gql from "graphql-tag";

export const GET_SINGLE_PRODUCT = gql`
  query getSingleProduct($slug: String) {
    products(where: { slugIn: [$slug] }) {
      nodes {
        ... on SimpleProduct {
          image {
            id
            sourceUrl(size: LARGE)
          }
          id
          stockQuantity
          stockStatus
          productId
          name
          description
          slug
          onSale
          salePrice
          regularPrice
          productBarcode
          productOrigin {
            name
          }
          productDetails {
            afati
            barkodi
            kodiShifra
            pesha
            productExtraInfo {
              image {
                mediaItemUrl
              }
            }
          }
          galleryImages {
            nodes {
              mediaItemUrl
            }
          }
          productCategories(
            where: {
              hierarchical: true
              orderby: TERM_ID
            }
          ) {
            nodes {
              productCategoryId
              id
              name
            }
          }
          productTags {
            nodes {
              brandPhoto {
                brandPhoto {
                  sourceUrl
                  title
                }
              }
            }
          }
        }
      }
    }
  }
`;
